export enum TimingOptionsValue {
  standard = "Standard",
  unlimited = "Unlimited",
  custom = "Custom"
}

export type TimingOptionItem = {
  value: TimingOptionsValue
  label: string
}
